<template>
  <div class="login_body">

    <section>

      <div class="login_middle_form">

        <router-link to="/" class="login_middle_logo">
          <!-- <img src="../assets/logo_white.png" /> -->
        </router-link>

        <div class="tilte">指导与反馈-内容</div>
        <form :model="feedbackForm" :rules="rules" class="feedbackform">
            <dl class="formcolumn-item topmarg" >
              <dt class="formcolumn-item-tit">文献名：</dt>
              <dd class="formcolumn-item-ct">
                <input type="text" placeholder="输入文献名" name="name" v-model="feedbackForm.name">
              </dd>
              <span style="color:red" class="required">*</span>
            </dl>
            <dl class="formcolumn-item ">
              <dt class="formcolumn-item-tit">Doi号：</dt>
              <dd class="formcolumn-item-ct">
                <input type="text" placeholder="输入Doi号" name="doinumber" v-model="feedbackForm.doinumber">
              </dd>
            </dl>
            <dl class="formcolumn-item ">
              <dt class="formcolumn-item-tit">备注：</dt>
              <dd class="formcolumn-item-ct">
                <textarea type="text" placeholder="输入备注" name="remark" v-model="feedbackForm.remark"></textarea>
              </dd>
              <span style="color:red" class="required">*</span>
            </dl>

          <!-- <ul>
            <li>
              <input type="text" placeholder="文献名" name="name" v-model="feedbackForm.name">
            </li>
            <li>
              <input type="text" placeholder="Doi号" name="doinumber" v-model="feedbackForm.doinumber">
            </li>
            <li>
              <input type="text" placeholder="备注" name="remark" v-model="feedbackForm.remark">
            </li>
          </ul> -->
          <div data-v-2529d779="" class="login_misc_wrapper"></div>
          <div class="buttondiv">
            <a href="javascript:void(0)" class="login_btn" @click="feedbackconfirm">提 交</a>
          </div>
        </form>
      </div>

    </section>

    <LoginFooter></LoginFooter>
  </div>
</template>

<script scoped>
import LoginFooter from './footer/login_footer.vue';
import api from './../axios/api.js';
import md5 from './../assets/js/md5.min.js'


export default {
  components: {
    LoginFooter
  },
  data() {
    return {
      feedbackForm: {
        name: '',
        doinumber: '',
        remark: '',
        type:1
      },
      rules: {
        name: [{ required: true, message: "请输入文献名", trigger: "blur" }],
        doinumber: [{ required: true, message: "请输入Doi号", trigger: "blur" }],
        feedbackForm: [{ required: true, message: "请输入备注", trigger: "blur" }],
      }
    }
  },
  mounted() {
  },
  methods: {
    feedbackconfirm() {
      let that = this;
      if (!that.feedbackForm.name) {
        this.showMessage("文献名不能为空！");
      } else if (!that.feedbackForm.remark) {
        this.showMessage("备注不能为空！");
      } else {
        let urllist = '/action/ermqadqwapurkqnvn/adfeedback';
        api.getTableData(urllist, JSON.stringify(that.feedbackForm)).then(res => {
          if (res.result == 1) {
            that.showInfo('提交成功');
          }
        });
      }
    },
    showInfo(val) {
      toastr.info(val, "提醒", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
      return;
    },
    showMessage(val) {
      toastr.error(val, "错误", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true
      });
    }
    
  }
}
</script>


<style scoped>
section {
  padding-top: 0;
  margin: auto;
}

.form-select {
  width: 100%;
  border: 1px solid #d6d6d6;
  border-radius: 5px;
  padding: 0 10px;
  font-size: 14px;
  color: #333;
  height: 45px;
  line-height: 45px;
  -webkit-transition: all 0.2s linear 0s;
  transition: all 0.2s linear 0s;
}

 .tilte {
    font-size: 21px;
    color: #fff;
    margin-bottom: 30px;
    font-weight: bold;
}

.buttondiv {
  text-align:center;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.login_middle_form ul {
    background: #fff;
    border-radius: 10px;
    width: 500px;
    overflow: hidden;
}

.feedbackform {
    padding: 18px 30px 0 30px;
    background: #fff;
    border-radius: 10px;
    width: 500px;
    overflow: hidden;
}

.feedbackform .formcolumn-item {
    margin-bottom: 10px;
}

.feedbackform .formcolumn-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 12px;
}

.feedbackform .formcolumn-item-tit {
    font-size: 14px;
    color: #333333;
    line-height: 36px;
    width: 60px;
    text-align:right;
}

.feedbackform .formcolumn-item-ct {
    width: calc(100% - 100px);
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 38px;
}

.feedbackform .formcolumn-item-ct {
    width: calc(100% - 100px);
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 38px;
}

.feedbackform .formcolumn-item-ct input {
    /* width: 90%; */
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    border: 1px solid #dedede;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: border-color 0.15s ease-in-out 0s, -webkit-box-shadow 0.15s ease-in-out 0s;
    transition: border-color 0.15s ease-in-out 0s, -webkit-box-shadow 0.15s ease-in-out 0s;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s, -webkit-box-shadow 0.15s ease-in-out 0s;
}

.feedbackform .formcolumn-item-ct input {
    width: 100%;
    border: 1px solid #d6d6d6;
    border-radius: 5px;
    padding: 0 10px;
    font-size: 14px;
    color: #333;
    height: 45px;
    line-height: 45px;
    -webkit-transition: all 0.2s linear 0s;
    transition: all 0.2s linear 0s;
}

.feedbackform .formcolumn-item-ct textarea {
    width: 100%;
    height: 150px;
    padding: 5px 10px;
    border: 1px solid #dedede;
    border-radius: 3px;
    box-shadow: none;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    resize: none;
}

.feedbackform .footer_btn input {
    background: var(--bgColor);
    color: #fff;
    width: 40%;
    padding: 0;
    font-size: 16px;
    height: 40px;
    -webkit-transition: all 0.2s linear 0s;
    transition: all 0.2s linear 0s;
}

.feedbackform.footer_btn input {
    background: var(--bgColor);
    width: 100%;
    border: 0;
    border-radius: 5px;
    height: 45px;
    line-height: 45px;
    padding: 0;
    font-size: 15px;
    color: #fff;
    text-align: center;
    margin-top: 20px;
    -webkit-transition: all 0.2s linear 0s;
    transition: all 0.2s linear 0s;
    cursor: pointer;
}

.login_middle_form .login_btn {
    display: block;
    width: 100px;
    border-radius: 5px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: var(--bgColor);
    font-size: 15px;
    color: #fff;
}

.topmarg{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/feedback.vue